module.exports = __webpack_public_path__ + "img/icon.dd8d29ac.png";